import { Link } from "react-router-dom";

export const LOGO_SRC = `${process.env.PUBLIC_URL}/scmbrain-logo.png`;

export const Logo = ({ className = "" }) => {
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center ${className}`}>
      <img src={LOGO_SRC} alt="SCMBrain" className="h-9 w-auto" />
    </Link>
  );
};

export default Logo;
